if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (!this.hasAttribute('data-primo-carousel')) return;
        this.track = this.querySelector('[role="document"]');
        this.slides = [...this.track.children].filter(slide => slide.hasAttribute('data-media-id'));
        this.querySelectorAll('[data-gallery-target]').forEach(button => button.addEventListener('click', () => {
          this.goToSlide(this.slides.findIndex(slide => slide.dataset.mediaId === button.dataset.galleryTarget));
        }));
        this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => this.goToSlide(this.slideIndex + Number(button.dataset.galleryStep))));
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.target.closest('deferred-media, product-model')) return;
          event.preventDefault();
          this.goToSlide(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.slideIndex + (event.key === 'ArrowRight' ? 1 : -1));
        });
        this.track.addEventListener('scroll', debounce(() => {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.updateSlide(index);
        }, 100));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      goToSlide(index, instant = false) {
        index = Math.max(0, Math.min(this.slides.length - 1, index));
        if (!this.slides[index]) return;
        this.updateSlide(index);
        this.track.scrollTo({ left: this.slides[index].offsetLeft - this.slides[0].offsetLeft, behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }

      updateSlide(index) {
        if (!this.slides[index]) return;
        if (this.slideIndex !== index) window.pauseAllMedia();
        this.slideIndex = index;
        this.slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
        this.querySelectorAll('[data-gallery-target]').forEach(button => {
          if (button.dataset.galleryTarget === this.slides[index].dataset.mediaId) {
            button.setAttribute('aria-current', 'true');
            button.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
          } else button.removeAttribute('aria-current');
        });
        const prev = this.querySelector('[data-gallery-step="-1"]');
        const next = this.querySelector('[data-gallery-step="1"]');
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === this.slides.length - 1;
      }

      showActiveMedia() {
        if (this.track) {
          // Variant updates replace the track contents without replacing this element.
          this.slides = [...this.track.children].filter(slide => slide.hasAttribute('data-media-id'));
          this.goToSlide(this.slides.findIndex(slide => slide.dataset.mediaId === this.openedBy.getAttribute('data-media-id')), true);
          return;
        }
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
